import {createStore} from "vuex";


const store = createStore({
    state(){
        return {
            integral: 0,
            //base_url: 'http://127.0.0.1:8000/api/v1'
            base_url: 'http://152.136.13.118:8081/api/v1'
        }
    },
    mutations: {
        integralFunc(state,payload){
            state.integral = payload;
       }
    }
})

export default store
